"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RequiredOption_1 = require("../RequiredOption");
class CreativeFormatPlaybackTime {
    constructor({ supportingPlaybackTimeId, requiredOption, seconds, }) {
        this.toJSON = () => ({
            supportingPlaybackTimeId: this.supportingPlaybackTimeId,
            requiredOption: this.requiredOption,
            seconds: this.seconds,
        });
        this.supportingPlaybackTimeId = supportingPlaybackTimeId;
        this.requiredOption = requiredOption;
        this.seconds = seconds;
    }
}
CreativeFormatPlaybackTime.fromJSON = (json) => {
    const { supportingPlaybackTimeId, requiredOption, seconds } = Object.assign({}, json);
    const _requiredOption = requiredOption ? RequiredOption_1.default.fromJSON(requiredOption) : undefined;
    if (typeof supportingPlaybackTimeId !== 'string')
        throw new Error('.supportingPlaybackTimeId must be a string');
    if (!Number.isSafeInteger(seconds))
        throw new Error('.seconds must be an integer');
    return new CreativeFormatPlaybackTime({ supportingPlaybackTimeId, requiredOption: _requiredOption, seconds });
};
exports.default = CreativeFormatPlaybackTime;
